import React, {useEffect, useState} from "react";
import {buildSingleOddsKey, isFobHorseLocked, isFobHorsePicked, pairPickCellState, pickFobHorse, pickFobHorseInSlot, pickFobPair} from "../fob.betting/fob-selection";
import lockIcon from "../../../assets/feather/lock.svg";
import {isSelectionRenderable} from "../selection-ready";
import {FobH2HTable} from "../fob.betting/fob-h2h-table";
import {OddsFlash} from "./odds-flash";
import {MutualBetslip, useMutualBetslip} from "../../../features/betslip/mutual.service";
import {useFobBetslip, useFobPendingPicks} from "../../../features/betslip/fob.service";
import {fobExcludedHorseNo, fobOddsEntry} from "../../../features/betslip/lib/selection-guard";
import {BettingTypesMap} from "../../../features/core/definitions";
import _ from "lodash";
import {getPrettyFormatLastSix} from "../../../features/bulletin/bulletin.service";
import jokeyIcon from "../../../assets/img/jokey.png";
import iconFather from "../../../assets/feather/father-at-yarisi.svg"
import infoIcon from "../../../assets/feather/info.svg";
import rightIcon from "../../../assets/feather/chevron-right.svg";
import leftIcon from "../../../assets/feather/chevron-left.svg";
import {courseColors} from "../../../constants/bulletin.constants";
import Modal from "react-modal";
import {FobMobileBetslip} from "../fob.betting/fob.betslip";
import {MutualMobileBetslip} from "../mutual.betting/mutual.betslip";
import {isMobile} from "../../../App";
import {useLocation} from "react-router-dom";
import paths from "../../../paths";
import {BottomSheet} from "react-spring-bottom-sheet";


let mobileFooterHeight: number = 58;


export function GetStablemateIcon({horse}: any) {

    return (<>

        {horse.stablemate && Number(horse.stablemate) === 1 ? <>
            <img alt={"iconFather"} src={iconFather} style={{marginTop: -3, filter: 'brightness(0)'}}/>
        </> : <>
        </>}

        {horse.stablemate && Number(horse.stablemate) === 2 ? <>
            <img alt={"iconFather"} src={iconFather}
                 style={{
                     marginTop: -3,
                     filter: 'invert(21%) sepia(100%) saturate(7414%) hue-rotate(359deg) brightness(94%) contrast(117%)'
                 }}/>
        </> : <>
        </>}

        {horse.stablemate && Number(horse.stablemate) === 3 ? <>
            <img alt={"iconFather"} src={iconFather} style={{marginTop: -3,}}/>
        </> : <>
        </>}


        {horse.stablemate && Number(horse.stablemate) === 4 ? <>
            <img alt={"iconFather"} src={iconFather}
                 style={{
                     marginTop: -3,
                     filter: 'invert(21%) sepia(100%) saturate(7414%) hue-rotate(216deg) brightness(100%) contrast(117%)'
                 }}/>
        </> : <>
        </>}

        {horse.stablemate && Number(horse.stablemate) === 5 ? <>
            <img alt={"iconFather"} src={iconFather}
                 style={{
                     marginTop: -3,
                     filter: 'invert(21%) sepia(100%) saturate(7414%) hue-rotate(130deg) brightness(100%) contrast(117%)'
                 }}/>
        </> : <>
        </>}
    </>)

}

export function BettingDataTable(prop: any) {
    const selection = prop.selection;
    const isFob = !!BettingTypesMap[Number(selection?.bettingType?.id)]?.isFob;
    const selectBettingColumn = prop.selectBettingColumn;
    const openCustomizeModal = prop.openCustomizeModal;
    const setOpenCustomizeModal = prop.setOpenCustomizeModal;
    const [showTrainingVideo, setShowTrainingVideo] = useState<any>(false);
    const [showHorseStat, setShowHorseStat] = useState<any>(false);
    const [showJockeyStat, setShowJockeyStat] = useState<any>(false);
    const [showHorsePedigri, setShowHorsePedigri] = useState<any>(false);
    const [openHorseDetail, setOpenHorseDetail] = useState(false);
    const [horseIndex, setHorseIndex] = useState(0);
    const parser = new DOMParser();
    const query = new URLSearchParams(useLocation().search);
    useFobBetslip();
    useFobPendingPicks();
    useMutualBetslip();

    function onDismiss() {
        setOpenHorseDetail(false);
    }

    useEffect(() => {

        mobileFooterHeight = document.getElementById("mobile-footer-menu")?.offsetHeight || 58;

    }, []);

    const scrollHandler = (event: any) => {

        const betSlip: any = document.getElementById("mobile-foot-betslip");
        const horseRows: any = document.getElementsByClassName("mobile-betting-table");

        try {
            if (betSlip && horseRows && horseRows.length > 0) {

                if (window.scrollY > (horseRows[horseRows.length - 1].offsetTop - betSlip.offsetTop + horseRows[horseRows.length - 1].offsetHeight)) {
                    betSlip.classList.remove('sticky')
                    betSlip.parentNode.classList.add('pb-2')
                }

                if (betSlip.offsetTop - window.scrollY > window.outerHeight - betSlip.offsetHeight - mobileFooterHeight) {
                    betSlip.classList.add('sticky')
                    betSlip.parentNode.classList.remove('pb-2')
                    betSlip.parentNode.style.paddingBottom = betSlip.offsetHeight + 'px';
                }

            }
        } catch (e) {
            console.error(e);
        }
    }

    useEffect(() => {
        window.addEventListener("scroll", scrollHandler);
        return () => {
            window.removeEventListener("scroll", scrollHandler);
        }
    }, []);

    if (!isSelectionRenderable(selection) || !selection.column) {
        return <></>;
    }

    // Kim Geçer'in oranları `event_odds`ta değil `fob_h2h`ta eşleşme olarak geliyor; at
    // tablosu bu türe uymuyor (bkz. fob-h2h-table.tsx başındaki not).
    const isHeadToHead = !!BettingTypesMap[Number(selection.bettingType.id)]?.isHeadToHead;

    const runs: any = selection.hippodrome.runs.filter((el: any) => selection.bettingSubType.label.split('-').map((el: any) => Number(el)).includes(Number(el.no)));

    let run: any = {};

    if (selection.bettingSubType.label.split('-').length > 1) {
        run = runs.find((el: any) => Number(el.no) === Number(selection.bettingSubType.label.split('-')[selection.column - 1]));
    } else {
        run = runs.find((el: any) => Number(el.no) === Number(selection.bettingSubType.id));
    }

    if (!run) {
        return <></>;
    }

    let minGanyan = _.orderBy(run?.horses, ['ganyan'], ['asc'])[0]

    const isFavoriteExcludedType = !!BettingTypesMap[Number(selection.bettingType.id)]?.isFavoriteExcluded;
    const favoriteNo = isFavoriteExcludedType ? fobExcludedHorseNo(run) : null;
    const favoriteBadge = <span style={{fontSize: 10, fontWeight: 700, padding: '1px 5px', borderRadius: 4, background: '#D4D6CE', color: '#3d4f4e', marginLeft: 6}}>FAVORİ</span>;
    const favoriteRowStyle = {opacity: 0.55, backgroundColor: '#F2F2F0', cursor: 'not-allowed'};

    const getHorsePedigri = () => {
        let url = "https://www.tjk.org/TR/YarisSever/Query/Pedigri/Pedigri?Atkodu=" + showHorsePedigri.code
        fetch(url)
            .then((response) => response.text())
            .then((html) => {
                let ob = document.getElementById("id_iframe_pedigri")
                if (ob) {

                    ob.innerHTML = html;
                }

            })
            .catch((error) => {
                console.warn(error);
            });
    }

    const getContentResults = (url: any) => {

        fetch(url)
            .then((response) => response.text())
            .then((html) => {
                let ob = document.getElementById("id_iframe_results")
                if (ob) {
                    const doc: any = parser.parseFromString(html, 'text/html');
                    let element: any = doc.getElementById(url.split('#')[1])

                }
            })
            .catch((error) => {
                console.warn(error);
            });
    }

    const getVideoSource = (videoUrl: any) => {

        fetch(videoUrl)
            .then((response) => response.text())
            .then((html) => {

                let finds: any = Array.from(html.matchAll(/var _vvy1(.*?)mp4/g));

                setShowTrainingVideo({training_video: finds[0][0].split('"')[1]})

            })
            .catch((error) => {
                console.warn(error);
            });

    }

    const getContentJockey = () => {
        let url = "https://www.tjk.org/TR/YarisSever/Query/Grouped/JokeyIstatistikleri?1=1&QueryParameter_JokeyId=" + showJockeyStat.jokey.code
        fetch(url)
            .then((response) => response.text())
            .then((html) => {
                let ob = document.getElementById("id_iframe")
                if (ob) {
                    const doc = parser.parseFromString(html, 'text/html');
                    let queryTable = doc.getElementById('queryTable')
                    if (queryTable) {

                        queryTable.classList.add('jockeyStats')
                        let aElements: any = queryTable.getElementsByTagName('a');
                        if (aElements) {
                            for (let a of aElements) {
                                if (a.getAttribute('href')) {
                                    a.removeAttribute('href');
                                }
                            }
                        }
                        ob.innerHTML = queryTable.outerHTML;
                    }
                }

            })
            .catch((error) => {
                console.warn(error);
            });
    }

    const slugify = (str: any) => {
        return String(str)
            .normalize('NFKD') // split accented characters into their base characters and diacritical marks
            .replace(/[\u0300-\u036f]/g, '') // remove all the accents, which happen to be all in the \u03xx UNICODE block.
            .trim() // trim leading or trailing whitespace
            .toLowerCase() // convert to lowercase
            .replace(/[^a-z0-9 -]/g, '') // remove non-alphanumeric characters
            .replace(/\s+/g, '-') // replace spaces with hyphens
            .replace(/-+/g, '-'); // remove consecutive hyphens
    }

    const getContentHorse = () => {
        let url = "https://www.tjk.org/TR/YarisSever/Query/ConnectedPage/AtKosuBilgileri?1=1&QueryParameter_AtId=" + showHorseStat.code
        fetch(url)
            .then((response) => response.text())
            .then((html) => {
                let ob = document.getElementById("id_iframe")
                if (ob) {
                    const doc = parser.parseFromString(html, 'text/html');
                    let tab1 = doc.getElementById('tabs-1')
                    if (tab1) {
                        let aElements: any = tab1.getElementsByTagName('a');
                        if (aElements) {
                            for (let a of aElements) {
                                a.removeAttribute('href');
                            }
                        }
                        ob.innerHTML = tab1.innerHTML;

                        let queryTable = doc.getElementById('queryTable') as HTMLTableElement;

                        let myRows: any = [];

                        // @ts-ignore
                        let headers = [...queryTable.getElementsByTagName('th')];
                        // @ts-ignore
                        let rows = [...queryTable.getElementsByTagName('tr')].forEach((el: any, index: number) => {
                            let cells = el.getElementsByTagName("td");
                            myRows[index] = {};
                            [...cells].forEach((cell: any, cellIndex: number) => {
                                myRows[index][slugify(headers[cellIndex].innerText)] = cell.innerText.replace(/^\s+|\s+$/g, '');
                            });
                        });
                        let myObj: any = {};
                        myObj.myrows = myRows;


                        if (queryTable) {
                            queryTable.classList.add('horseStats')
                            // @ts-ignore
                            let aElements: any = [...queryTable.getElementsByTagName('a')];

                            if (aElements) {

                                aElements.forEach((a: any, i: number) => {
                                    if (a.getAttribute('href')) {
                                        // Bu kısım video kaldırmak için !!
                                        if (a.getAttribute('id')) {
                                            if (a.getAttribute('id').indexOf('videoAnchor') !== -1) {

                                                a.remove()
                                            }
                                        } else if (a.getAttribute('href').indexOf('YarisVideoAt') !== -1) {

                                            let originUrl = a.getAttribute('href')
                                            a.removeAttribute('href', '#');

                                            a.addEventListener('click', () => {
                                                getVideoSource('https://www.tjk.org/' + originUrl);
                                            });


                                        } else if (a.getAttribute('href').indexOf('fotoftp') !== -1) {
                                            a.setAttribute('target', '_blank');

                                        } else if (a.getAttribute('href').indexOf('GunlukYarisSonuclari') !== -1) {

                                            let originUrl = a.getAttribute('href')
                                            a.removeAttribute('href', '#');


                                        } else {
                                            a.removeAttribute('href');
                                        }
                                    }
                                    a.removeAttribute('onClick');

                                })
                            }
                            ob.appendChild(queryTable);
                        }


                    }
                }

            })
            .catch((error) => {
                console.warn(error);
            });
    }

    const getHorseNameForOdd = (horsesNo: any) => {
        try {
            return run.horseMap[horsesNo.split('-')[0]].name + ' - ' + run.horseMap[horsesNo.split('-')[1]].name;
        } catch (e) {
            return run.horseMap[horsesNo].name;
        }

    }

    const calculateOdd = (eventOdd: any) => {
        if (eventOdd.show && Number(eventOdd.win_odds) > 1) {
            return eventOdd.win_odds;
        } else {
            if (eventOdd.status === 'o') {
                return 'KO'
            } else {
                return '🔒'
            }
        }
    }

    // Oran METNİ ile ÇİZİMİ ayrı: çizim, değişimi yanıp söndüren sarmalı da ekliyor.
    const renderOdd = (eventOdd: any) => (
        <OddsFlash entry={eventOdd}>{calculateOdd(eventOdd)}</OddsFlash>
    );

    const favoriteExcludedOdd = (horse: any) => {
        if (favoriteNo === String(horse.no)) {
            return <span style={{display: 'inline-block', minWidth: 50, padding: '8px 6px', borderRadius: 8, background: '#ECEDEA', color: '#5d6b6a', fontSize: 11, fontWeight: 600, textAlign: 'center'}}>Favori</span>;
        }
        const entry = fobOddsEntry(run, selection.bettingType.id, buildSingleOddsKey(selection.bettingType.id, horse.no));
        return entry ? renderOdd(entry) : '🔒';
    };

    const pairPickOdd = (horse: any) => {
        const cell = pairPickCellState(selection.hippodrome, run, horse, selection.bettingType.id, selection.column);
        switch (cell.kind) {
            case 'pair':
                return cell.entry ? renderOdd(cell.entry) : '🔒';
            case 'open':
                return '–';
            default:
                return '🔒';
        }
    };

    const handleOddClick = (horse: any) => {
        const isHorse = horse.no !== undefined && horse.win_odds === undefined;

        if (isHorse) {
            // FOB kendi store'unu tutuyor; iki aşamalı at seçimi de orada çözülüyor.
            if (isFob) {
                const isPairPick = !!BettingTypesMap[Number(selection.bettingType.id)]?.isFobPairPick;
                const probeKey = isPairPick
                    ? String(Number(horse.no))
                    : buildSingleOddsKey(selection.bettingType.id, horse.no);
                if (fobOddsEntry(run, selection.bettingType.id, probeKey)?.status !== "o") {
                    return;
                }
                if (isPairPick) {
                    // Sekmedeki kolon yuva: 1. At / 2. At. Öteki yuvadaki at kilitli, tıklama düşer.
                    pickFobHorseInSlot(selection.hippodrome, run, horse, Number(selection.bettingType.id), selection.column);
                    return;
                }
                pickFobHorse(selection.hippodrome, run, horse, Number(selection.bettingType.id));
                return;
            }

            MutualBetslip.add(Number(selection.column), run, horse, 'toggle');
            return;
        }

        const horseNos = horse.horse_no.toString().split('-');
        const firstHorse = run.horseMap[Number(horseNos[0])];
        const secondHorse = horseNos[1] ? run.horseMap[Number(horseNos[1])] : null;

        if (isFob) {
            if (secondHorse) {
                pickFobPair(selection.hippodrome, run, firstHorse, secondHorse, Number(selection.bettingType.id));
            } else {
                pickFobHorse(selection.hippodrome, run, firstHorse, Number(selection.bettingType.id));
            }
            return;
        }

        MutualBetslip.add(1, run, firstHorse, 'toggle');
        if (secondHorse) {
            setTimeout(() => {
                MutualBetslip.add(2, run, secondHorse, 'toggle');
            }, 250);
        }
    }

    if (isHeadToHead) {
        // Kim Geçer kendi tablosuyla erken dönüyor; mobil kupon şeridi aşağıdaki ortak
        // dönüşte olduğu için bu dalda hiç çizilmiyordu - kullanıcı eşleşmeyi seçiyor
        // ama kuponu göremiyordu. Şerit burada da çizilmeli.
        return (<div className="">
            <FobH2HTable hippodrome={selection.hippodrome} run={run} bettingTypeId={selection.bettingType.id}/>
            {isMobile &&
                <FobMobileBetslip selectBettingColumn={selectBettingColumn} selectedBettingType={selection.bettingType}/>}
        </div>);
    }

    return (<div className="betting-page">

        {!isMobile && <div className="betting-run-info">
            <div className={"row align-items-center"}>
                <div className={"col-11 d-flex align-items-center p-0"}>
                    {selection.bettingType.columnLabel === 'Ayak' &&
                        <div className={"race-badge me-2"}>
                            {run.no}. Koşu
                        </div>
                    }
                    <div className="d-flex align-items-center me-2">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"
                             className="me-2">
                            <path fillRule="evenodd" clipRule="evenodd"
                                  d="M0.666626 8.00002C0.666626 3.94993 3.94987 0.666687 7.99996 0.666687C12.05 0.666687 15.3333 3.94993 15.3333 8.00002C15.3333 12.0501 12.05 15.3334 7.99996 15.3334C3.94987 15.3334 0.666626 12.0501 0.666626 8.00002ZM8.66663 4.00002C8.66663 3.63183 8.36815 3.33335 7.99996 3.33335C7.63177 3.33335 7.33329 3.63183 7.33329 4.00002V8.00002C7.33329 8.25254 7.47596 8.48338 7.70182 8.59631L10.3685 9.92964C10.6978 10.0943 11.0983 9.96082 11.2629 9.6315C11.4276 9.30218 11.2941 8.90173 10.9648 8.73707L8.66663 7.588V4.00002Z"
                                  fill="#353535">
                            </path>
                        </svg>
                        <span className="text-xxsmall text-bold">{run.time}</span>
                    </div>
                    <div className="d-flex align-items-center me-2">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path fillRule="evenodd" clipRule="evenodd"
                                  d="M7.99996 0.666687C3.94987 0.666687 0.666626 3.94993 0.666626 8.00002C0.666626 12.0501 3.94987 15.3334 7.99996 15.3334C12.05 15.3334 15.3333 12.0501 15.3333 8.00002C15.3333 3.94993 12.05 0.666687 7.99996 0.666687ZM7.99996 4.66669C7.63177 4.66669 7.33329 4.96516 7.33329 5.33335C7.33329 5.70154 7.63177 6.00002 7.99996 6.00002H8.00663C8.37482 6.00002 8.67329 5.70154 8.67329 5.33335C8.67329 4.96516 8.37482 4.66669 8.00663 4.66669H7.99996ZM8.66663 8.00002C8.66663 7.63183 8.36815 7.33335 7.99996 7.33335C7.63177 7.33335 7.33329 7.63183 7.33329 8.00002V10.6667C7.33329 11.0349 7.63177 11.3334 7.99996 11.3334C8.36815 11.3334 8.66663 11.0349 8.66663 10.6667V8.00002Z"
                                  fill="#353535">
                            </path>
                        </svg>
                    </div>
                    <div className={"d-flex"}>
                        <p className="course text-xxsmall text-white text-bold"
                           style={{backgroundColor: courseColors[run.course]}}>{run.distance}m - {run.course}</p>
                        <div className="d-flex align-items-center">
                            <p className="text-xxsmall text-bold ms-1"> {run.type_detail ? <>
                                <span>{run.type_detail}</span>
                            </> : null} {run.short ? `/ ${run.short}` : ''} | {run.group} |
                                İkramiye: <span className={"text-bolder"}>{run.prize_1} {run.currency}</span>
                            </p>
                        </div>
                    </div>
                    <span>
</span>
                </div>
            </div>
        </div>}

        {isMobile && <>
            <div className="betting-race-info-wrapper d-flex justify-content-between align-content-center">
                <div className={"d-flex flex-column"}>
                    <div className="d-flex align-items-center">
                        {run.no}.Koşu <span>&nbsp;|&nbsp;</span> {run.time} <span>&nbsp;|&nbsp;</span>
                        <div
                            className="betting-race-info-item betting-race-info-bottom-section" style={{
                            backgroundColor: courseColors[run.course],
                            border: `1px solid ${courseColors[run.course]}`
                        }}>
                            <span className="text-xxxsmall text-white text-bold">{run.distance}</span>
                            <span className="text-xxxsmall text-white text-bold">&nbsp;{run.course}</span>
                        </div>
                        &nbsp;{selection.hippodrome.weather?.temperature}°C

                    </div>
                    <div className={"mt-1"}>
                        {run.group} <span>&nbsp;|&nbsp;</span> {run.type_detail} {run.special_name != '' &&
                        <span>&nbsp;|&nbsp;</span>} {run.special_name}
                    </div>

                </div>
                <div className={"d-flex align-items-center"}>

                    {!!BettingTypesMap[Number(selection.bettingType?.id)]?.isFobPairPick ?
                        <div className={"d-flex align-items-center justify-content-end  p-0 pe-1"}>
                            <div style={{minHeight: "33px"}} onClick={(e: any) => {
                                setOpenCustomizeModal(true);
                            }}
                                 className={`btn-link text-small lh-xxxs text-white fw-regular py-0 px-2`}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 15 14"
                                     fill="none">
                                    <path
                                        d="M3.58325 1.16659C3.58325 0.844419 3.32208 0.583252 2.99992 0.583252C2.67775 0.583252 2.41659 0.844419 2.41659 1.16659V2.04159H1.54159C1.21942 2.04159 0.958252 2.30275 0.958252 2.62492C0.958252 2.94708 1.21942 3.20825 1.54159 3.20825H2.41659V4.08325C2.41659 4.40542 2.67775 4.66659 2.99992 4.66659C3.32208 4.66659 3.58325 4.40542 3.58325 4.08325V3.20825H4.45825C4.78042 3.20825 5.04159 2.94708 5.04159 2.62492C5.04159 2.30275 4.78042 2.04159 4.45825 2.04159H3.58325V1.16659Z"
                                        fill="#FFFFFF">
                                    </path>
                                    <path
                                        d="M3.58325 9.91659C3.58325 9.59442 3.32208 9.33325 2.99992 9.33325C2.67775 9.33325 2.41659 9.59442 2.41659 9.91659V10.7916H1.54159C1.21942 10.7916 0.958252 11.0528 0.958252 11.3749C0.958252 11.6971 1.21942 11.9583 1.54159 11.9583H2.41659V12.8333C2.41659 13.1554 2.67775 13.4166 2.99992 13.4166C3.32208 13.4166 3.58325 13.1554 3.58325 12.8333V11.9583H4.45825C4.78042 11.9583 5.04159 11.6971 5.04159 11.3749C5.04159 11.0528 4.78042 10.7916 4.45825 10.7916H3.58325V9.91659Z"
                                        fill="#FFFFFF">
                                    </path>
                                    <path
                                        d="M8.5027 1.54051C8.41606 1.31524 8.19962 1.16659 7.95825 1.16659C7.71689 1.16659 7.50045 1.31524 7.4138 1.54051L6.4022 4.17068C6.22696 4.62629 6.1719 4.75759 6.09658 4.86351C6.021 4.9698 5.92813 5.06267 5.82185 5.13824C5.71592 5.21356 5.58463 5.26863 5.12902 5.44386L2.49885 6.45547C2.27357 6.54211 2.12492 6.75855 2.12492 6.99992C2.12492 7.24129 2.27357 7.45773 2.49885 7.54437L5.12902 8.55597C5.58463 8.73121 5.71592 8.78627 5.82185 8.8616C5.92814 8.93717 6.021 9.03004 6.09658 9.13632C6.1719 9.24225 6.22696 9.37354 6.4022 9.82915L7.4138 12.4593C7.50045 12.6846 7.71689 12.8333 7.95825 12.8333C8.19962 12.8333 8.41606 12.6846 8.5027 12.4593L9.51431 9.82915C9.68954 9.37354 9.74461 9.24225 9.81993 9.13632C9.89551 9.03004 9.98837 8.93717 10.0947 8.8616C10.2006 8.78627 10.3319 8.73121 10.7875 8.55597L13.4177 7.54437C13.6429 7.45773 13.7916 7.24129 13.7916 6.99992C13.7916 6.75855 13.6429 6.54211 13.4177 6.45547L10.7875 5.44386C10.3319 5.26863 10.2006 5.21356 10.0947 5.13824C9.98837 5.06267 9.89551 4.9698 9.81993 4.86351C9.74461 4.75759 9.68954 4.62629 9.51431 4.17068L8.5027 1.54051Z"
                                        fill="#FFFFFF">
                                    </path>
                                </svg>
                                Oranlar
                            </div>
                        </div> : <img src={infoIcon} alt={"info"}/>}
                </div>

            </div>
            <div className={"betting-mobile"}>
                {(!isFob) &&
                    <div className={"d-flex mobile-betting-nav-container"}>
                        <div onClick={(e: any) => {
                            if (!isFob) {
                                MutualBetslip.addAll(Number(selection.column), run, MutualBetslip.isAddedAll(Number(selection.column), run) === false ? 'add' : 'remove');
                            }

                        }}
                             className={`w-25 betting-nav d-flex justify-content-center align-items-center ${MutualBetslip.isAddedAll(Number(selection.column), run) ? 'select-all-horse-mobile' : ''}`}>
                            <div className="">

                                {!isFob &&
                                    <p className={`text-xxxsmall text-bold text-center lh-xxxs ${MutualBetslip.isAddedAll(Number(selection.column), run) ? 'text-primary' : ''}`}>H{MutualBetslip.isAddedAll(Number(selection.column), run) &&
                                        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8"
                                             fill="none">
                                            <path d="M6.66658 2L2.99992 5.66667L1.33325 4" stroke="var(--primary-color)"
                                                  stroke-width="1.6" stroke-linecap="round"
                                                  stroke-linejoin="round"></path>
                                        </svg>}</p>}


                            </div>
                        </div>
                        <div className={"w-100 d-flex align-items-center justify-content-center betting-nav"}>
                            <a className=""
                               title="Muhtemeller"
                               href={`${paths.possibles.url}/${selection.hippodrome.keyword.toLowerCase()}${selection.hippodrome._id}/${run.no}`}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 15 14"
                                     fill="none">
                                    <path
                                        d="M3.58325 1.16659C3.58325 0.844419 3.32208 0.583252 2.99992 0.583252C2.67775 0.583252 2.41659 0.844419 2.41659 1.16659V2.04159H1.54159C1.21942 2.04159 0.958252 2.30275 0.958252 2.62492C0.958252 2.94708 1.21942 3.20825 1.54159 3.20825H2.41659V4.08325C2.41659 4.40542 2.67775 4.66659 2.99992 4.66659C3.32208 4.66659 3.58325 4.40542 3.58325 4.08325V3.20825H4.45825C4.78042 3.20825 5.04159 2.94708 5.04159 2.62492C5.04159 2.30275 4.78042 2.04159 4.45825 2.04159H3.58325V1.16659Z"
                                        fill="#1F3735">
                                    </path>
                                    <path
                                        d="M3.58325 9.91659C3.58325 9.59442 3.32208 9.33325 2.99992 9.33325C2.67775 9.33325 2.41659 9.59442 2.41659 9.91659V10.7916H1.54159C1.21942 10.7916 0.958252 11.0528 0.958252 11.3749C0.958252 11.6971 1.21942 11.9583 1.54159 11.9583H2.41659V12.8333C2.41659 13.1554 2.67775 13.4166 2.99992 13.4166C3.32208 13.4166 3.58325 13.1554 3.58325 12.8333V11.9583H4.45825C4.78042 11.9583 5.04159 11.6971 5.04159 11.3749C5.04159 11.0528 4.78042 10.7916 4.45825 10.7916H3.58325V9.91659Z"
                                        fill="#1F3735">
                                    </path>
                                    <path
                                        d="M8.5027 1.54051C8.41606 1.31524 8.19962 1.16659 7.95825 1.16659C7.71689 1.16659 7.50045 1.31524 7.4138 1.54051L6.4022 4.17068C6.22696 4.62629 6.1719 4.75759 6.09658 4.86351C6.021 4.9698 5.92813 5.06267 5.82185 5.13824C5.71592 5.21356 5.58463 5.26863 5.12902 5.44386L2.49885 6.45547C2.27357 6.54211 2.12492 6.75855 2.12492 6.99992C2.12492 7.24129 2.27357 7.45773 2.49885 7.54437L5.12902 8.55597C5.58463 8.73121 5.71592 8.78627 5.82185 8.8616C5.92814 8.93717 6.021 9.03004 6.09658 9.13632C6.1719 9.24225 6.22696 9.37354 6.4022 9.82915L7.4138 12.4593C7.50045 12.6846 7.71689 12.8333 7.95825 12.8333C8.19962 12.8333 8.41606 12.6846 8.5027 12.4593L9.51431 9.82915C9.68954 9.37354 9.74461 9.24225 9.81993 9.13632C9.89551 9.03004 9.98837 8.93717 10.0947 8.8616C10.2006 8.78627 10.3319 8.73121 10.7875 8.55597L13.4177 7.54437C13.6429 7.45773 13.7916 7.24129 13.7916 6.99992C13.7916 6.75855 13.6429 6.54211 13.4177 6.45547L10.7875 5.44386C10.3319 5.26863 10.2006 5.21356 10.0947 5.13824C9.98837 5.06267 9.89551 4.9698 9.81993 4.86351C9.74461 4.75759 9.68954 4.62629 9.51431 4.17068L8.5027 1.54051Z"
                                        fill="#1F3735">
                                    </path>
                                </svg>
                                <span className="text-xsmall">Muhtemeller</span>
                            </a>
                        </div>
                        <div className={"w-100 d-flex align-items-center justify-content-center betting-nav"}>
                            <a className=""
                               title="AGF" href={paths.agf.url}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"
                                     fill="none">
                                    <path fillRule="evenodd" clipRule="evenodd"
                                          d="M9 0.75C4.44365 0.75 0.75 4.44365 0.75 9C0.75 13.5563 4.44365 17.25 9 17.25C13.5563 17.25 17.25 13.5563 17.25 9C17.25 4.44365 13.5563 0.75 9 0.75ZM12.5303 6.53033C12.8232 6.23744 12.8232 5.76256 12.5303 5.46967C12.2374 5.17678 11.7626 5.17678 11.4697 5.46967L5.46967 11.4697C5.17678 11.7626 5.17678 12.2374 5.46967 12.5303C5.76256 12.8232 6.23744 12.8232 6.53033 12.5303L12.5303 6.53033ZM5.625 6.75C5.625 6.12868 6.12868 5.625 6.75 5.625C7.37132 5.625 7.875 6.12868 7.875 6.75C7.875 7.37132 7.37132 7.875 6.75 7.875C6.12868 7.875 5.625 7.37132 5.625 6.75ZM10.125 11.25C10.125 10.6287 10.6287 10.125 11.25 10.125C11.8713 10.125 12.375 10.6287 12.375 11.25C12.375 11.8713 11.8713 12.375 11.25 12.375C10.6287 12.375 10.125 11.8713 10.125 11.25Z"
                                          fill="#1F3735">
                                    </path>
                                </svg>
                                <span className="text-xsmall">AGF</span>
                            </a>
                        </div>

                    </div>}
                {run.horses.map((horse: any, keyHorse: number) => {
                    let horseIsAdded: any = (isFob
                        ? isFobHorsePicked(selection.hippodrome, run, horse, Number(selection.bettingType.id), selection.column)
                        : MutualBetslip.isAdded(Number(selection.column), run, horse) !== false) ? 'horse-added' : '';
                    const horseIsLocked = isFob && isFobHorseLocked(selection.hippodrome, run, horse, Number(selection.bettingType.id), selection.column);
                    const isFavorite = favoriteNo === String(horse.no);
                    return <div className={"horse-container"} key={"horse-key-" + keyHorse}
                                style={isFavorite ? favoriteRowStyle : !horse.run_status ? {opacity: 0.7, cursor: 'not-allowed'} : {}}>
                        <div onClick={() => {
                            handleOddClick(horse);
                        }} className={`${horseIsAdded ? 'mobile-betting-selected' : ''}`}>
                            <div className={`mobile-betting-horse-no ${horseIsLocked ? 'locked-horse' : ''}`}
                                 style={isFavorite ? {background: '#E3E5E0'} : {}}>
                                        <span
                                            className={`text-small fw-medium text-center  ${horseIsAdded ? 'text-primary' : 'text-primary'}`}>{horse.no}</span>
                                {horseIsLocked && <img src={lockIcon} width={10} alt={"kilitli"}/>}
                                {horseIsAdded && <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8"
                                                      viewBox="0 0 8 8"
                                                      fill="none">
                                    <path d="M6.66658 2L2.99992 5.66667L1.33325 4" stroke="#1F3735"
                                          strokeWidth="1.6" strokeLinecap="round"
                                          strokeLinejoin="round"></path>
                                </svg>}
                            </div>

                        </div>
                        <div
                            className={`horse-info d-flex justify-content-between align-items-center  ${horseIsAdded ? 'selected' : ''}`}>
                            <div onClick={() => {
                                handleOddClick(horse);
                            }}>
                                <div className={"d-flex align-items-center"}>
                                    <img src={`https://medya-cdn.tjk.org/formaftp/${horse.owner.code}.jpg`}
                                         onError={({currentTarget}) => {
                                             currentTarget.onerror = null;
                                             currentTarget.src = jokeyIcon;
                                         }} width={25} height={25} alt={horse.jokey.short_name}
                                         className="jockey-uniform float-start  me-1"/>
                                    <div className={"d-flex flex-column justify-content-between"}>
                                        <div className="betting-horse-name text-truncate">
                                            {horse.name}
                                            {isFavorite && favoriteBadge}
                                            {!horse.run_status && <span className="text-xsmall">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg" width="16"
                                        height="16" viewBox="0 0 16 16" fill="none">
                                        <g
                                            clipPath="url(#clip0_4878_930)">
                                        <path
                                            d="M5.21362 10.7066C3.97829 8.84342 4.85022 7.38859 4.85022 7.38859C4.64738 7.32734 4 7.76075 4 7.76075C4.36397 6.39575 6.36725 5.23667 6.36725 5.23667C6.14499 5.15325 5.5176 5.31834 5.5176 5.31834C7.15691 3.70659 9.16019 4.30625 9.16019 4.30625C9.22076 3.95392 10.2127 3.33325 10.2127 3.33325C10.111 3.43592 10.0698 3.99534 10.0698 3.99534C10.1721 3.80867 10.4967 3.62259 10.4967 3.62259C10.3144 4.05659 10.4967 4.98759 10.4967 4.98759C11.0223 5.526 11.6092 7.38859 11.6092 7.38859L11.832 7.71934C12.116 8.1335 12.0114 8.78509 11.7309 8.93967C10.6789 9.52067 10.5767 8.46425 10.5767 8.46425C9.70701 8.361 9.05906 7.36759 9.05906 7.36759C7.886 7.98767 8.53909 9.73884 9.04591 10.4108C9.69672 11.2724 9.21962 12.6666 9.21962 12.6666C9.21962 12.6666 6.43296 12.5488 5.21362 10.7066Z"
                                            fill="#353535">
                                        </path>
                                        <path
                                            d="M3.28634 3.28659L12.713 12.7133M14.6663 7.99992C14.6663 11.6818 11.6816 14.6666 7.99967 14.6666C4.31778 14.6666 1.33301 11.6818 1.33301 7.99992C1.33301 4.31802 4.31778 1.33325 7.99967 1.33325C11.6816 1.33325 14.6663 4.31802 14.6663 7.99992Z"
                                            stroke="#E04C4C" strokeWidth="1.33333" strokeLinecap="round"
                                            strokeLinejoin="round">
                                        </path>
                                        </g>
                                        <defs>
                                        <clipPath id="clip0_4878_930">
                                        <rect
                                            width="16" height="16" fill="white">
                                        </rect>
                                        </clipPath>
                                        </defs>
                                        </svg>
                                </span>}
                                            <GetStablemateIcon horse={horse}/>
                                        </div>
                                        <div className={"d-flex justify-content-start align-items-center"}>
                                            <span
                                                className="betting-horse-weight text-truncate">{horse.weight} kg</span>&nbsp;
                                            <span className="betting-horse-info text-truncate">{horse.age}</span>&nbsp;
                                            <span
                                                className="betting-horse-info text-truncate text-danger">{horse.jewelry}</span>

                                        </div>
                                    </div>
                                </div>
                                {(!isFob) && <>
                                    {horse.agf_ratio1 ? <div style={{
                                        width: '150px',

                                        marginTop: "4px"
                                    }}>
                                        <div style={{position: "relative"}}>
                                            <div
                                                style={{
                                                    height: "16px",
                                                    width: `${horse.agf_ratio1}%`,
                                                    backgroundColor: horse.agf_sort_no1 == 1 ? "#FFE700" : "#9CAFAE",
                                                    borderRadius: "2px 0px 0px 2px",
                                                    position: "relative",
                                                    zIndex: 2
                                                }}>
                                            </div>
                                            <div
                                                style={{
                                                    position: "absolute",
                                                    top: "0px",
                                                    width: '150px',
                                                    height: "100%",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    borderRadius: "2px",
                                                    border: "1px solid #F3F6F6",
                                                    backgroundColor: horse.agf_sort_no1 == 1 ? "#FFFACC" : "#F3F6F6"
                                                }}>
                                                <p className={`text-xxxsmall text-center lh-xxxsmsll z-2 `}>{horse.agf_ratio1} ({horse.agf_sort_no1})</p>
                                            </div>
                                        </div>
                                    </div> : <div style={{height: "19px", marginTop: "4px"}}>
                                    </div>}
                                </>}
                            </div>

                            <div onClick={() => {
                                if (!isFob) {
                                    setOpenHorseDetail(true);
                                    setHorseIndex(keyHorse);
                                } else {
                                    handleOddClick(horse);
                                }
                            }} className={"d-flex flex-column align-items-end"}>
                                <div className={"jokey-name"}>
                                    {horse.jokey.short_name}
                                </div>
                                <div className={"d-flex justify-content-start align-items-center"}>

                                    <span className="betting-horse-info text-truncate">ST: {horse.start}</span>&nbsp;
                                    {(!isFob) && <><span
                                        className="betting-horse-info text-truncate">KGS: {horse.kgs}</span>&nbsp;</>}
                                    {(!isFob) && <><span
                                        className="betting-horse-info text-truncate">HP: {horse.handicap}</span>&nbsp;</>}
                                    <div
                                        style={{fontSize: "12px", textAlign: "center",}}
                                        dangerouslySetInnerHTML={{__html: getPrettyFormatLastSix(horse.last6)}}>
                                    </div>
                                </div>
                                {(!isFob) && <>
                                    {horse.agf_ratio2 ?
                                        <div style={{width: '150px', marginTop: "4px"}}>
                                            <div style={{position: "relative"}}>
                                                <div
                                                    style={{
                                                        height: "16px",
                                                        width: `${horse.agf_ratio2}%`,
                                                        backgroundColor: horse.agf_sort_no2 == 1 ? "#FFE700" : "#9CAFAE",
                                                        borderRadius: "2px 0px 0px 2px",
                                                        position: "relative",
                                                        zIndex: 2
                                                    }}>
                                                </div>
                                                <div
                                                    style={{
                                                        position: "absolute",
                                                        top: "0px",
                                                        width: '150px',
                                                        height: "100%",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        borderRadius: "2px",
                                                        border: "1px solid #F3F6F6",
                                                        backgroundColor: horse.agf_sort_no2 == 1 ? "#FFFACC" : "#F3F6F6"
                                                    }}>

                                                    <p className={`text-xxxsmall text-center lh-xxxsmsll`}>{horse.agf_ratio2} ({horse.agf_sort_no2})</p>
                                                </div>
                                            </div>
                                        </div> : <div style={{height: "19px", marginTop: "4px"}}>
                                        </div>}
                                </>}
                            </div>
                        </div>
                        {(isFob) && (!!!BettingTypesMap[Number(selection.bettingType?.id)]?.isFobPairPick) &&
                            <div className={`horse-odd-container ${horseIsAdded ? 'selected' : ''}`}>
                                <div className={"horse-odd"} onClick={() => {
                                    setOpenHorseDetail(true);
                                    setHorseIndex(keyHorse);
                                }}>
                                    {selection.bettingType.id === 1881 && <>{renderOdd(run.event_odds[Number(horse.no)])}</>}
                                    {selection.bettingType.id === 1882 && <>{renderOdd(run.event_odds[Number(horse.no)])}</>}
                                    {selection.bettingType.id === 1886 && <>{renderOdd(run.event_odds && run.event_odds[horse.no + 'T2'])}</>}
                                    {selection.bettingType.id === 1887 && <>{renderOdd(run.event_odds && run.event_odds[horse.no + 'T3'])}</>}
                                    {selection.bettingType.id === 1888 && <>{renderOdd(run.event_odds && run.event_odds[horse.no + 'T4'])}</>}
                                    {!!BettingTypesMap[Number(selection.bettingType?.id)]?.isFavoriteExcluded && <>{favoriteExcludedOdd(horse)}</>}
                                </div>

                            </div>}
                        {(isFob) && (!!BettingTypesMap[Number(selection.bettingType?.id)]?.isFobPairPick) &&
                            <div className={`horse-odd-container ${horseIsAdded ? 'selected' : ''}`} onClick={() => {
                                setOpenHorseDetail(true);
                                setHorseIndex(keyHorse);
                            }}>
                                <span className={"text-xxsmall me-1"}>{pairPickOdd(horse)}</span>
                                <img src={rightIcon} alt={"horse-"}/>
                            </div>
                        }
                    </div>
                })}
            </div>
        </>}

        {isMobile &&
            (isFob
                ? <FobMobileBetslip selectBettingColumn={selectBettingColumn} selectedBettingType={selection.bettingType}/>
                : <MutualMobileBetslip selectBettingColumn={selectBettingColumn}/>)}

        {!isMobile && <table className="betting-table w-100">
            <thead>
            <tr>
                <th>
                    {!isFob &&
                        <button onClick={(e: any) => {
                            MutualBetslip.addAll(Number(selection.column), run, MutualBetslip.isAddedAll(Number(selection.column), run) === false ? 'add' : 'remove');

                        }}
                                className={`button tertiary filled select-all-horse ${MutualBetslip.isAddedAll(Number(selection.column), run) ? 'selected-horse-all' : ''}`}>
                            <span className="text-xxxsmall text-bold text-center lh-xxxsmall">H</span>
                            {MutualBetslip.isAddedAll(Number(selection.column), run) &&
                                <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8"
                                     fill="none">
                                    <path d="M6.66658 2L2.99992 5.66667L1.33325 4" stroke="var(--primary-color)"
                                          strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
                                    </path>
                                </svg>}
                        </button>}
                </th>
                <th className={"horse-name-col"}>
                    <span className="text-xxxsmall text-white text-bold lh-xxxsmall">Atın İsmi</span>
                </th>
                <th className={"text-center"}>
                    <span className="text-xxxsmall text-white text-bold lh-xxxsmall">Yaş</span>
                </th>
                <th className={"text-center"}>
                    <span className="text-xxxsmall text-white text-center text-bold lh-xxxsmall">Kilo</span>
                </th>
                <th className={"text-center"}>
                    <span className="text-xxxsmall text-white text-center text-bold lh-xxxsmall">Jokey</span>
                </th>
                <th className={"text-center"}>
                    <span className="text-xxxsmall text-white text-center text-bold lh-xxxsmall">Orijin</span>
                </th>
                <th className={"text-center"}>
                    <span className="text-xxxsmall text-white text-center text-bold lh-xxxsmall">S/A</span>
                </th>
                <th className={"text-center"}>
                    <span className="text-xxxsmall text-white text-center text-bold lh-xxxsmall">Start</span>
                </th>
                <th className={"text-center"}>
                    <span className="text-xxxsmall text-white text-center text-bold lh-xxxsmall">Hp</span>
                </th>
                <th className={"text-center"}>
                    <span className="text-xxxsmall text-white text-center text-bold lh-xxxsmall">Son 6</span>
                </th>
                <th className={"text-center"}>
                    <span className="text-xxxsmall text-white text-center text-bold lh-xxxsmall">KGS</span>
                </th>
                <th className={"text-center"}>
                    <span className="text-xxxsmall text-white text-center text-bold lh-xxxsmall">En İyi Derece</span>
                </th>
                <th className={"text-center"}>
                    <span className="text-xxxsmall text-white text-center text-bold lh-xxxsmall">Ganyan</span>
                </th>
                {isFob && <th className={"text-center"}>
                    <span className="text-xxxsmall text-white text-center text-bold lh-xxxsmall">{isFavoriteExcludedType ? 'Favori Hariç' : 'Sabit Ganyan'}</span>
                </th>}
                <th className={"text-center"}>
                    <span className="text-xxxsmall text-white text-center text-bold lh-xxxsmall">İdman</span>
                </th>
                <th className={"text-center"}>
                    <span className="text-xxxsmall text-white text-center text-bold lh-xxxsmall">AGF</span>
                </th>
            </tr>
            </thead>
            <tbody>
            {run.horses.map((horse: any, keyHorse: number) => {
                let horseIsAdded: any = (isFob
                        ? isFobHorsePicked(selection.hippodrome, run, horse, Number(selection.bettingType.id), selection.column)
                        : MutualBetslip.isAdded(Number(selection.column), run, horse) !== false) ? 'horse-added' : '';
                // Çift atlı FOB türünde öteki yuvadaki at bu sekmede seçilemez: kilit çizilir.
                const horseIsLocked = isFob && isFobHorseLocked(selection.hippodrome, run, horse, Number(selection.bettingType.id), selection.column);
                const isFavorite = favoriteNo === String(horse.no);

                return (<React.Fragment key={`DataTable-horses-${keyHorse}`}>
                    <tr key={`races-${keyHorse}`}
                        style={isFavorite ? favoriteRowStyle : !horse.run_status || horseIsLocked ? {opacity: 0.7, cursor: 'not-allowed'} : {}}
                        className={`${horseIsAdded}`}>
                        <td className="horse-button" style={isFavorite ? {backgroundColor: '#D4D6CE'} : {}}>
                            {/* Koşmayacak ata YENİ bahis eklenmez ama ZATEN SEÇİLMİŞ bir at
                                kaldırılabilmeli: at çekilince kullanıcı o seçimi kuponundan
                                çıkaramıyor, kuponu tümden silmekten başka çıkışı kalmıyordu. */}
                            <button disabled={(!horse.run_status && !horseIsAdded) || horseIsLocked || isFavorite} onClick={(e: any) => {
                                handleOddClick(horse);
                            }}
                                    className={`button tertiary filled select-all-horse ${horseIsAdded ? 'selected-horse' : ''} ${horseIsLocked ? 'locked-horse' : ''}`}>
                                {horseIsLocked
                                    ? <img src={lockIcon} width={11} alt={"kilitli"}/>
                                    : <span className="text-xxxsmall text-bold text-center lh-xxxsmall">{horse.no}</span>}
                                {horseIsAdded &&
                                    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8"
                                         fill="none">
                                        <path d="M6.66658 2L2.99992 5.66667L1.33325 4" stroke="white" strokeWidth="1.6"
                                              strokeLinecap="round" strokeLinejoin="round">
                                        </path>
                                    </svg>}
                            </button>
                        </td>
                        <td className="horse-name" onClick={() => {
                            handleOddClick(horse);
                        }}>
                            <div className={"d-flex align-items-center"}>
                                <div>
                                     <span className="jockey-image-border">
                                    <img src={`https://medya-cdn.tjk.org/formaftp/${horse.owner.code}.jpg`}
                                         onError={({currentTarget}) => {
                                             currentTarget.onerror = null;
                                             currentTarget.src = jokeyIcon;
                                         }} width={16} height={18} alt={horse.jokey.short_name}
                                         className="jockey-uniform float-start "/>
                                </span>
                                </div>
                                <div className="d-flex flex-wrap w-100">
                                <span onClick={() => {
                                    if (horse.code && Number(horse.code) > 0) {
                                        setShowHorseStat(horse);
                                    }
                                }}
                                      className=" cursor-pointer text-xxxsmall text-center d-flex align-items-center justify-content-center text-truncate  lh-xxxsmall text-bold mb-1">{horse.name}{isFavorite && favoriteBadge}</span>
                                    <span className="text-xxxsmall w-100 text-danger">{horse.jewelry}</span>
                                    <div className={"w-100 d-flex mt-1"}>
                                        <GetStablemateIcon horse={horse}/>
                                        {!horse.run_status && <span className="text-xsmall">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg" width="16"
                                        height="16" viewBox="0 0 16 16" fill="none">
                                        <g
                                            clipPath="url(#clip0_4878_930)">
                                        <path
                                            d="M5.21362 10.7066C3.97829 8.84342 4.85022 7.38859 4.85022 7.38859C4.64738 7.32734 4 7.76075 4 7.76075C4.36397 6.39575 6.36725 5.23667 6.36725 5.23667C6.14499 5.15325 5.5176 5.31834 5.5176 5.31834C7.15691 3.70659 9.16019 4.30625 9.16019 4.30625C9.22076 3.95392 10.2127 3.33325 10.2127 3.33325C10.111 3.43592 10.0698 3.99534 10.0698 3.99534C10.1721 3.80867 10.4967 3.62259 10.4967 3.62259C10.3144 4.05659 10.4967 4.98759 10.4967 4.98759C11.0223 5.526 11.6092 7.38859 11.6092 7.38859L11.832 7.71934C12.116 8.1335 12.0114 8.78509 11.7309 8.93967C10.6789 9.52067 10.5767 8.46425 10.5767 8.46425C9.70701 8.361 9.05906 7.36759 9.05906 7.36759C7.886 7.98767 8.53909 9.73884 9.04591 10.4108C9.69672 11.2724 9.21962 12.6666 9.21962 12.6666C9.21962 12.6666 6.43296 12.5488 5.21362 10.7066Z"
                                            fill="#353535">
                                        </path>
                                        <path
                                            d="M3.28634 3.28659L12.713 12.7133M14.6663 7.99992C14.6663 11.6818 11.6816 14.6666 7.99967 14.6666C4.31778 14.6666 1.33301 11.6818 1.33301 7.99992C1.33301 4.31802 4.31778 1.33325 7.99967 1.33325C11.6816 1.33325 14.6663 4.31802 14.6663 7.99992Z"
                                            stroke="#E04C4C" strokeWidth="1.33333" strokeLinecap="round"
                                            strokeLinejoin="round">
                                        </path>
                                        </g>
                                        <defs>
                                        <clipPath id="clip0_4878_930">
                                        <rect
                                            width="16" height="16" fill="white">
                                        </rect>
                                        </clipPath>
                                        </defs>
                                        </svg>
                                </span>}
                                    </div>


                                </div>
                            </div>
                        </td>
                        <td className={"age"}>
                            <span
                                className="text-xxxsmall text-center d-flex align-items-center justify-content-center text-truncate  lh-xxxsmall">{horse.age}</span>
                        </td>
                        <td className={"weight"}>
                            <span
                                className="text-xxxsmall text-center d-flex align-items-center justify-content-center text-truncate  lh-xxxsmall">{horse.weight}</span>
                        </td>
                        <td className={"jockey"}>
                            <div className="d-flex align-items-center cursor-pointer" onClick={() => {
                                if (horse.jokey && Number(horse.jokey.code) > 0) {
                                    setShowJockeyStat(horse)
                                }
                            }}>

                                <span className="text-xxxsmall lh-xxxsmall text-bold">{horse.jokey.short_name}</span>
                            </div>
                        </td>
                        <td className={"pedigri"}>
                            <div className="d-flex justify-content-center align-items-center">
                                <span className={"tooltip"}>
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg" width="12" height="14" viewBox="0 0 12 14"
                                        fill="none">
<path
    d="M10.1796 11.06C12.0326 8.26525 10.7247 6.083 10.7247 6.083C11.0289 5.99113 12 6.64125 12 6.64125C11.454 4.59375 8.44912 2.85512 8.44912 2.85512C8.78252 2.73 9.7236 2.97763 9.7236 2.97763C7.26463 0.56 4.25971 1.4595 4.25971 1.4595C4.16886 0.931 2.68097 0 2.68097 0C2.83353 0.154 2.89524 0.993125 2.89524 0.993125C2.74182 0.713125 2.255 0.434 2.255 0.434C2.52841 1.085 2.255 2.4815 2.255 2.4815C1.46649 3.28912 0.586268 6.083 0.586268 6.083L0.252007 6.57912C-0.173962 7.20038 -0.017116 8.17775 0.40371 8.40963C1.98159 9.28113 2.13501 7.6965 2.13501 7.6965C3.43949 7.54162 4.41142 6.0515 4.41142 6.0515C6.171 6.98163 5.19136 9.60838 4.43113 10.6164C3.45491 11.9088 4.17058 14 4.17058 14C4.17058 14 8.35055 13.8232 10.1796 11.06Z"
    fill="#1F3735">
</path>
                                    </svg>
                                    <span className={"tooltip-text"}>Baba: {horse.father}</span>
                                </span>
                                <span className={"tooltip"}>
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg" width="12" height="14" viewBox="0 0 12 14"
                                        fill="none">
<path
    d="M1.82044 11.06C-0.0325689 8.26525 1.27533 6.083 1.27533 6.083C0.971071 5.99113 0 6.64125 0 6.64125C0.545959 4.59375 3.55088 2.85512 3.55088 2.85512C3.21748 2.73 2.2764 2.97763 2.2764 2.97763C4.73537 0.56 7.74029 1.4595 7.74029 1.4595C7.83114 0.931 9.31903 0 9.31903 0C9.16647 0.154 9.10476 0.993125 9.10476 0.993125C9.25818 0.713125 9.745 0.434 9.745 0.434C9.47159 1.085 9.745 2.4815 9.745 2.4815C10.5335 3.28912 11.4137 6.083 11.4137 6.083L11.748 6.57912C12.174 7.20038 12.0171 8.17775 11.5963 8.40963C10.0184 9.28113 9.86499 7.6965 9.86499 7.6965C8.56051 7.54162 7.58858 6.0515 7.58858 6.0515C5.829 6.98163 6.80864 9.60838 7.56887 10.6164C8.54509 11.9088 7.82942 14 7.82942 14C7.82942 14 3.64945 13.8232 1.82044 11.06Z"
    fill="#E67776">
</path>
                                    </svg>
                                    <span className={"tooltip-text"}>Ana: {horse.mother}</span>
                                </span>
                            </div>
                            {horse.code ?
                                <div className="d-flex justify-content-center align-items-center cursor-pointer"
                                     onClick={() => {
                                         setShowHorsePedigri(horse)
                                     }}>
                                    <span className="text-xsmall more">Pedigri</span>
                                </div> : <></>}
                        </td>
                        <td className={"trainer"}>
                            <div className="d-flex justify-content-center align-items-center"
                                 style={{columnGap: '2px'}}>
                                <span className={"tooltip"}>
                                    <svg width="18"
                                         height="18"
                                         viewBox="0 0 18 19"
                                         fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <rect
                                            x="0.5" y="1" width="17" height="17" rx="8.5" fill="white">
</rect>
                                        <rect x="0.5"
                                              y="1"
                                              width="17"
                                              height="17"
                                              rx="8.5"
                                              stroke="#E8E6D0">

                                        </rect>
                                        <path
                                            fillRule="evenodd" clipRule="evenodd"
                                            d="M7.66085 10.5416C8.55362 10.5418 9.4464 10.5418 10.3392 10.5416C10.642 10.5416 10.8483 10.5415 11.0284 10.5733C11.891 10.7254 12.5663 11.4007 12.7184 12.2632C12.7501 12.4434 12.7501 12.6497 12.75 12.9525C12.75 13.0185 12.752 13.0849 12.7405 13.1502C12.6949 13.4089 12.4923 13.6115 12.2335 13.6572C12.1768 13.6672 12.117 13.6668 12.0873 13.6667C10.0293 13.6557 7.97071 13.6557 5.91273 13.6667C5.88299 13.6668 5.82322 13.6672 5.76648 13.6572C5.50772 13.6115 5.30513 13.4089 5.25951 13.1502C5.248 13.0849 5.25002 13.0185 5.25001 12.9525C5.24994 12.6497 5.24989 12.4434 5.28166 12.2632C5.43375 11.4007 6.10905 10.7254 6.97158 10.5733C7.15175 10.5415 7.35807 10.5416 7.66085 10.5416Z"
                                            fill="#353535">

                                        </path>
                                        <path fillRule="evenodd" clipRule="evenodd"
                                              d="M6.70835 7.62498C6.70835 6.35933 7.73436 5.33331 9.00001 5.33331C10.2657 5.33331 11.2917 6.35933 11.2917 7.62498C11.2917 8.89063 10.2657 9.91665 9.00001 9.91665C7.73436 9.91665 6.70835 8.89063 6.70835 7.62498Z"
                                              fill="#353535">

                                        </path>
                            </svg>
                                    <span className={"tooltip-text"}>
                                        Sahibi: {horse.owner?.name}
                                    </span>
                            </span>
                                <span className={"tooltip"}>
                                <svg width="18" height="18"
                                     viewBox="0 0 18 19" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
<rect
    x="0.5" y="1" width="17" height="17" rx="8.5" fill="white">
</rect>
<rect x="0.5"
      y="1"
      width="17"
      height="17"
      rx="8.5"
      stroke="#E8E6D0">
</rect>
<path
    fillRule="evenodd" clipRule="evenodd"
    d="M13.7286 9.0924L12.3047 7.18803C12.3006 7.18195 12.2958 7.17635 12.2903 7.17136L12.2006 7.07137C11.9304 6.76693 11.5741 6.36695 10.9249 6.25473L10.8484 5.99807C10.8229 5.91026 10.7786 5.82812 10.7182 5.75653C10.6578 5.68495 10.5825 5.6254 10.4969 5.58142C10.4153 5.53924 10.3254 5.51277 10.2325 5.50361C10.1396 5.49445 10.0458 5.50277 9.95645 5.52809L9.61211 5.62476C9.4275 5.67844 9.27273 5.79696 9.18073 5.95508C9.08873 6.1132 9.06676 6.29845 9.11951 6.47139L9.19962 6.72249C9.12005 6.81327 9.05297 6.91293 8.99995 7.01915C8.94693 6.91293 8.87985 6.81327 8.80028 6.72249L8.88039 6.4725C8.93339 6.29999 8.91212 6.1151 8.82109 5.95689C8.73006 5.79869 8.57639 5.67959 8.39257 5.62476L8.04345 5.52809C7.95414 5.50277 7.86025 5.49445 7.7674 5.50361C7.67454 5.51277 7.58463 5.53924 7.50303 5.58142C7.41748 5.62555 7.3423 5.68515 7.28192 5.75671C7.22155 5.82827 7.17721 5.91034 7.15152 5.99807L7.075 6.25473C6.42577 6.36584 6.06948 6.76693 5.79927 7.07137L5.7096 7.17136L5.69525 7.18803L4.23778 9.12573C3.76209 9.60951 3.49887 10.2414 3.50008 10.8968C3.49435 11.5806 3.78059 12.2386 4.29607 12.7265C4.81155 13.2145 5.51421 13.4927 6.25002 13.5C6.70131 13.4918 7.1438 13.3825 7.53993 13.1814C7.93605 12.9804 8.2741 12.6934 8.52538 12.345C8.77665 11.9965 8.93371 11.5968 8.98324 11.1799C8.98493 11.1657 8.98649 11.1514 8.98793 11.1372C9.0191 11.4888 9.12805 11.8311 9.30829 12.1423C9.50238 12.4775 9.77429 12.7683 10.1043 12.9937C10.4343 13.2191 10.8142 13.3735 11.2163 13.4456C11.6185 13.5177 12.0329 13.5057 12.4294 13.4106C12.826 13.3154 13.1948 13.1395 13.5091 12.8955C13.8235 12.6515 14.0754 12.3455 14.2468 11.9998C14.4181 11.6541 14.5046 11.2773 14.4998 10.8968C14.5013 10.2257 14.2252 9.5797 13.7286 9.0924ZM9.18886 9.94459C9.08343 10.181 9.01697 10.4302 8.99102 10.6836C8.9692 10.4331 8.90844 10.186 8.80985 9.95014L8.99995 8.67797L9.18886 9.94459ZM6.25002 13.0556C5.64085 13.0488 5.05946 12.8177 4.63353 12.4129C4.20761 12.0082 3.97195 11.4629 3.97833 10.8968C3.97744 10.4972 4.09491 10.1051 4.31789 9.76348C4.40092 9.6354 4.49831 9.51585 4.60843 9.40683C4.8179 9.19694 5.07167 9.02942 5.3539 8.91472C5.63614 8.80003 5.94078 8.74061 6.24882 8.74019C6.85174 8.75803 7.42354 8.9931 7.8433 9.39568C8.26305 9.79826 8.49784 10.3368 8.49799 10.8973C8.49815 11.4579 8.26366 11.9965 7.84413 12.3993C7.4246 12.8021 6.85292 13.0374 6.25002 13.0556ZM11.7499 13.0556C11.143 13.0428 10.5657 12.8098 10.1414 12.4064C9.71706 12.0031 9.47949 11.4614 9.47949 10.8973C9.47949 10.3333 9.71706 9.79159 10.1414 9.38823C10.5657 8.98488 11.143 8.75187 11.7499 8.73908C12.0494 8.73949 12.3458 8.79564 12.6216 8.90422C12.8973 9.0128 13.1469 9.17161 13.3556 9.37127L13.7047 9.83348C13.719 9.85214 13.7364 9.86863 13.7561 9.88237C13.9317 10.1955 14.0228 10.5436 14.0216 10.8968C14.0279 11.4629 13.7923 12.0082 13.3664 12.4129C12.9404 12.8177 12.359 13.0488 11.7499 13.0556ZM6.25002 9.31463C5.80612 9.32556 5.38436 9.4971 5.07455 9.79273C4.76475 10.0884 4.59139 10.4847 4.59139 10.8973C4.59139 11.31 4.76475 11.7063 5.07455 12.002C5.38436 12.2976 5.80612 12.4691 6.25002 12.4801C6.69391 12.4691 7.11568 12.2976 7.42548 12.002C7.73529 11.7063 7.90865 11.31 7.90865 10.8973C7.90865 10.4847 7.73529 10.0884 7.42548 9.79273C7.11568 9.4971 6.69391 9.32556 6.25002 9.31463ZM10.7952 9.5679C11.0793 9.39726 11.4117 9.30908 11.7499 9.3146C12.1974 9.31871 12.625 9.48757 12.9387 9.78415C13.2525 10.0807 13.4269 10.4809 13.4238 10.8968C13.4239 11.2111 13.3234 11.5184 13.135 11.7795C12.9466 12.0406 12.6788 12.2436 12.3657 12.3628C12.0527 12.4819 11.7086 12.5118 11.3772 12.4485C11.0458 12.3853 10.7422 12.2318 10.5051 12.0076C10.2679 11.7834 10.1079 11.4987 10.0455 11.1898C9.98307 10.8808 10.021 10.5616 10.1545 10.2727C10.2881 9.9839 10.5111 9.73853 10.7952 9.5679Z"
    fill="#353535">
</path>
                                                            </svg>
                                    <span className={"tooltip-text"}>Antrenör: {horse.trainer.name}</span>
                            </span>
                            </div>

                        </td>

                        <td className={"start"}>
                            <span
                                className="text-xxxsmall text-center d-flex align-items-center justify-content-center text-truncate  lh-xxxsmall">{horse.start}</span>
                        </td>
                        <td className={"hp"}>
                            <span
                                className="text-xxxsmall text-center d-flex align-items-center justify-content-center text-truncate  lh-xxxsmall">{horse.handicap}</span>
                        </td>
                        <td className={"last-six"}>
                            <span
                                className="text-xxxsmall text-center d-flex align-items-center justify-content-center text-truncate  lh-xxxsmall"
                                dangerouslySetInnerHTML={{__html: getPrettyFormatLastSix(horse.last6)}}>
</span>
                        </td>
                        <td className={"kgs"}>
                            <span
                                className="text-xxxsmall text-center d-flex align-items-center justify-content-center text-truncate  lh-xxxsmall">{horse.kgs}</span>
                        </td>
                        <td className={"eid"}>
                            <span
                                className="text-xxxsmall text-center d-flex align-items-center justify-content-center text-truncate  lh-xxxsmall">{horse.best_time}</span>
                        </td>
                        <td className={"ganyan"}>
                            <span
                                className="text-xxxsmall text-center d-flex align-items-center justify-content-center text-truncate  lh-xxxsmall">{horse.ganyan}</span>
                        </td>

                        {isFob &&
                            <td className={`${minGanyan === horse ? "text-success fw-bold" : ""}`}>
                            <span
                                className="text-xxxsmall text-center d-flex align-items-center justify-content-center text-truncate  lh-xxxsmall">
                                {selection.bettingType.id === 1881 && <>{renderOdd(run.event_odds[Number(horse.no)])}</>}
                                {selection.bettingType.id === 1882 && <>{renderOdd(run.event_odds[Number(horse.no)])}</>}
                                {selection.bettingType.id === 1886 && <>{renderOdd(run.event_odds && run.event_odds[horse.no + 'T2'])}</>}
                                {selection.bettingType.id === 1887 && <>{renderOdd(run.event_odds && run.event_odds[horse.no + 'T3'])}</>}
                                {selection.bettingType.id === 1888 && <>{renderOdd(run.event_odds && run.event_odds[horse.no + 'T4'])}</>}
                                {!!BettingTypesMap[Number(selection.bettingType?.id)]?.isFavoriteExcluded && <>{favoriteExcludedOdd(horse)}</>}
                                {!!BettingTypesMap[Number(selection.bettingType?.id)]?.isFobPairPick && <>{pairPickOdd(horse)}</>}
                            </span>
                            </td>}
                        <td className={"idm"}>
                            <p className={"text-center"}>-</p>
                        </td>
                        <td className={"agf"}>
                            <div className="d-flex justify-content-center">
                                <div className="d-flex">
                                    {horse.agf_ratio1 ? <div style={{
                                        width: horse.agf_ratio2 ? "48px" : '87px',
                                        marginRight: horse.agf_ratio2 ? "6px" : '0'
                                    }}>
                                        <div style={{position: "relative"}}>
                                            <div
                                                style={{
                                                    height: "16px",
                                                    width: `${horse.agf_ratio1}%`,
                                                    backgroundColor: "rgb(217, 217, 217)",
                                                    borderRadius: "2px 0px 0px 2px"
                                                }}>
                                            </div>
                                            <div
                                                style={{
                                                    position: "absolute",
                                                    top: "0px",
                                                    width: horse.agf_ratio2 ? "48px" : '87px',
                                                    height: "100%",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    borderRadius: "2px",
                                                    border: "1px solid rgb(217, 217, 217)"
                                                }}>

                                                <p className={`text-xxxsmall text-center lh-xxxsmsll z-2 ${horse.agf_sort_no1 == 1 ? 'text-success' : ''}`}>{horse.agf_ratio1} ({horse.agf_sort_no1})</p>
                                            </div>
                                        </div>
                                    </div> : <></>}
                                    {horse.agf_ratio2 ? <div style={{width: horse.agf_ratio1 ? "48px" : '87px',}}>
                                        <div style={{position: "relative"}}>
                                            <div
                                                style={{
                                                    height: "16px",
                                                    width: `${horse.agf_ratio2}%`,
                                                    backgroundColor: "rgb(217, 217, 217)",
                                                    borderRadius: "2px 0px 0px 2px"
                                                }}>
                                            </div>
                                            <div
                                                style={{
                                                    position: "absolute",
                                                    top: "0px",
                                                    width: horse.agf_ratio1 ? "48px" : '87px',
                                                    height: "100%",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    borderRadius: "2px",
                                                    border: "1px solid rgb(217, 217, 217)"
                                                }}>

                                                <p className={`text-xxxsmall text-center lh-xxxsmsll z-2 ${horse.agf_sort_no2 == 1 ? 'text-success' : ''}`}>{horse.agf_ratio2} ({horse.agf_sort_no2})</p>
                                            </div>
                                        </div>
                                    </div> : <>
                                    </>}
                                </div>
                            </div>
                        </td>
                    </tr>
                </React.Fragment>)
            })}
            </tbody>
        </table>}

        <BottomSheet open={openHorseDetail} onDismiss={onDismiss}
                     snapPoints={({minHeight}) => minHeight}>
            <div className={"horse-detail-wrapper"}>
                <div className={"d-flex justify-content-start align-items-center text-header"}>
                    <img src={`https://medya-cdn.tjk.org/formaftp/${run.horses[horseIndex].owner.code}.jpg`}
                         onError={({currentTarget}) => {
                             currentTarget.onerror = null;
                             currentTarget.src = jokeyIcon;
                         }} width={28} height={28} alt={run.horses[horseIndex].jokey.short_name}
                         className="jockey-uniform float-start  me-1"/> {run.horses[horseIndex].name}
                </div>
                <div className={"d-flex justify-content-start align-items-center"} style={{gap: "6px"}}>
                    <div className={"info-box m-0 p-2 info-text"}>
                        {run.horses[horseIndex].age}
                    </div>
                    <div className={"info-box m-0 p-2 info-text"}>
                        {run.group}
                    </div>
                </div>
                <div className={"horse-detail-container"}>
                    <div className={"d-flex horse-detail-row"}>
                        <div>
                            Ganyan
                        </div>
                        <div>
                            {run.horses[horseIndex].ganyan}
                        </div>
                    </div>
                    <div className={"d-flex horse-detail-row"}>
                        <div>
                            KGS
                        </div>
                        <div>
                            {run.horses[horseIndex].kgs}
                        </div>
                    </div>
                    <div className={"d-flex horse-detail-row"}>
                        <div>
                            HP
                        </div>
                        <div>
                            {run.horses[horseIndex].handicap}
                        </div>
                    </div>
                    <div className={"d-flex horse-detail-row"}>
                        <div>
                            Baba & Anne
                        </div>
                        <div>
                            {run.horses[horseIndex].father}
                            <br/>
                            {run.horses[horseIndex].mother}
                        </div>
                    </div>
                    <div className={"d-flex horse-detail-row"}>
                        <div>
                            Pedigri
                        </div>
                        <div className={"detail-btn"} onClick={() => {
                            setOpenHorseDetail(false);
                            setShowHorsePedigri(run.horses[horseIndex]);

                        }}>
                            İncele
                        </div>
                    </div>
                    <div className={"d-flex horse-detail-row"}>
                        <div>
                            En İyi Derece
                        </div>
                        <div>
                            {run.horses[horseIndex].eid}
                        </div>
                    </div>
                    <div className={"d-flex horse-detail-row"}>
                        <div>
                            Sahibi
                        </div>
                        <div>
                            {run.horses[horseIndex].owner.name}
                        </div>
                    </div>
                    <div className={"d-flex horse-detail-row"}>
                        <div>
                            Antranör
                        </div>
                        <div>
                            {run.horses[horseIndex].trainer.name}
                        </div>
                    </div>
                    <div className={"d-flex horse-detail-row"}>
                        <div>
                            Galop
                        </div>
                        <div className={"detail-btn"}>
                            İncele
                        </div>
                    </div>
                    <div className={"d-flex horse-detail-row"}>
                        <div>
                            Son Yarışları
                        </div>
                        <div className={"detail-btn"}>
                            İncele
                        </div>
                    </div>
                    <div className={"d-flex horse-detail-row"}>
                        <div>
                            Son İdman
                        </div>
                        <div className={"detail-btn"}>
                            İncele
                        </div>
                    </div>
                </div>
                <div className={"row"}>
                    <div className={"col-2 p-0"}>
                        <div className={`btn custom-btn-close-sm w-100 ${horseIndex !== 0 ? 'active' : ''}`}
                             onClick={() => {
                                 if (horseIndex !== 0) {
                                     setHorseIndex(horseIndex - 1);
                                 }
                             }}>
                            <img src={leftIcon}/>
                        </div>
                    </div>
                    <div className={"col-8"}>
                        <div className={"btn custom-btn-close w-100"} onClick={() => {
                            setOpenHorseDetail(false);
                        }}>
                            Kapat
                        </div>
                    </div>
                    <div className={"col-2 p-0"}>
                        <div
                            className={`btn custom-btn-close-sm w-100 ${horseIndex !== run.horses.length - 1 ? 'active' : ''}`}
                            onClick={() => {
                                if (horseIndex !== run.horses.length - 1) {
                                    setHorseIndex(horseIndex + 1);
                                }
                            }}>
                            <img src={rightIcon}/>
                        </div>
                    </div>
                </div>


            </div>
        </BottomSheet>

        <Modal
            isOpen={showHorseStat !== false}
            onRequestClose={() => {
                setShowHorseStat(false);
            }}
            onAfterOpen={getContentHorse}
            style={{
                content: {
                    top: '50%',
                    left: '50%',
                    right: 'auto',
                    bottom: 'auto',
                    width: '920px',
                    maxHeight: 'calc(100% - 40px)',
                    marginRight: '-50%',
                    maxWidth: ' calc( 100% - 40px )',
                    padding: '0px',
                    transform: 'translate(-50%, -50%)',
                    background: 'var(--bs-white)',
                    borderRadius: 'var(--bs-border-radius-xl)',
                    border: 0
                },
                overlay: {
                    zIndex: 5,
                    backgroundColor: 'rgba(0, 0, 0, 0.25)',
                    backdropFilter: 'blur(10px)',
                }
            }}
            contentLabel=""
        >

            <div className={"modal-header"}>


                <h5 className="w-100 text-center text-bolder align-self-center mb-0 text-white">{showHorseStat.name}</h5>
                <div onClick={() => {
                    setShowHorseStat(false);
                }}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="white"
                         xmlns="http://www.w3.org/2000/svg">
                        <path d="M18 6L6 18M6 6L18 18" stroke="white" strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"></path>
                    </svg>
                </div>
            </div>

            <div className="modal-body  py-4">
                <div className="tjkIframe" id="id_iframe">
                    <p className="p-5 text-center">Yükleniyor.</p>
                </div>
            </div>

        </Modal>

        <Modal
            isOpen={showJockeyStat !== false}
            onRequestClose={() => {
                setShowJockeyStat(false);
            }}
            onAfterOpen={getContentJockey}
            style={{
                content: {
                    top: '50%',
                    left: '50%',
                    right: 'auto',
                    bottom: 'auto',
                    width: '920px',
                    maxHeight: 'calc(100% - 40px)',
                    marginRight: '-50%',
                    maxWidth: ' calc( 100% - 40px )',
                    padding: '0px',
                    transform: 'translate(-50%, -50%)',
                    background: 'var(--bs-white)',
                    borderRadius: 'var(--bs-border-radius-xl)',
                    border: 0
                },
                overlay: {
                    zIndex: 5,
                    backgroundColor: 'rgba(0, 0, 0, 0.25)',
                    backdropFilter: 'blur(10px)',
                }
            }}
            contentLabel=""
        >
            <div className={"modal-header"}>


                <h5 className="w-100 text-center text-bolder align-self-center mb-0 text-white">{showJockeyStat.jokey && showJockeyStat.jokey.name}</h5>
                <div onClick={() => {
                    setShowJockeyStat(false);
                }}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="white"
                         xmlns="http://www.w3.org/2000/svg">
                        <path d="M18 6L6 18M6 6L18 18" stroke="white" strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"></path>
                    </svg>
                </div>
            </div>

            <div className="modal-body  py-4">
                <div className="tjkIframe" id="id_iframe">
                    <p className="p-5 text-center">Yükleniyor.</p>
                </div>
            </div>


        </Modal>

        <Modal
            isOpen={showHorsePedigri !== false}
            onRequestClose={() => {
                setShowHorsePedigri(false)
            }}
            onAfterOpen={getHorsePedigri}
            style={{
                content: {
                    top: '50%',
                    left: '50%',
                    right: 'auto',
                    bottom: 'auto',
                    width: '920px',
                    maxHeight: 'calc(100% - 40px)',
                    marginRight: '-50%',
                    maxWidth: ' calc( 100% - 40px )',
                    padding: '0px',
                    transform: 'translate(-50%, -50%)',
                    background: 'var(--bs-white)',
                    borderRadius: 'var(--bs-border-radius-xl)',
                    border: 0
                },
                overlay: {
                    zIndex: 5,
                    backgroundColor: 'rgba(0, 0, 0, 0.25)',
                    backdropFilter: 'blur(10px)',
                }
            }}
            contentLabel=""
        >


            <div className={"modal-header"}>


                <h5 className="w-100 text-center text-bolder align-self-center mb-0 text-white">{showHorsePedigri.name}</h5>
                <div onClick={() => {
                    setShowHorsePedigri(false);
                }}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="white"
                         xmlns="http://www.w3.org/2000/svg">
                        <path d="M18 6L6 18M6 6L18 18" stroke="white" strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"></path>
                    </svg>
                </div>
            </div>
            <div className="modal-body py-4">
                <div className="tjkIframe" id="id_iframe_pedigri">
                    <p className="p-5 text-center">Yükleniyor.</p>
                </div>
            </div>


        </Modal>

        <Modal
            isOpen={showTrainingVideo !== false}
            onRequestClose={() => {
                setShowTrainingVideo(false);
            }}
            ariaHideApp={false}
            style={{
                content: {
                    top: '50%',
                    left: '50%',
                    right: 'auto',
                    bottom: 'auto',
                    width: '940px',
                    maxHeight: 'calc(100% - 40px)',
                    marginRight: '-50%',
                    maxWidth: ' calc( 100% - 40px )',
                    padding: '0px',
                    transform: 'translate(-50%, -50%)',
                    background: 'var(--bs-white)',
                    borderRadius: 'var(--bs-border-radius-xl)',
                    border: 0
                },
                overlay: {
                    zIndex: 5,
                    backgroundColor: 'rgba(0, 0, 0, 0.25)',
                    backdropFilter: 'blur(10px)',
                }
            }} contentLabel="">


            <div className="modal-header">
                <h3 className="text-lg mb-0 text-white text-bolder text-center w-100">İdman</h3>
                <svg onClick={() => setShowTrainingVideo(false)} width="24" height="24" viewBox="0 0 24 24" fill="white"
                     xmlns="http://www.w3.org/2000/svg">
                    <path d="M18 6L6 18M6 6L18 18" stroke="white" strokeWidth="2" strokeLinecap="round"
                          strokeLinejoin="round">
                    </path>
                </svg>
            </div>
            <div className={"p-2"}>
                <video controls autoPlay style={{width: '100%'}}>
                    <source
                        src={showTrainingVideo && showTrainingVideo.training_video ? showTrainingVideo.training_video : null}
                        type="video/mp4"/>
                </video>
            </div>

        </Modal>

        <Modal
            isOpen={openCustomizeModal}
            style={{
                content: {
                    top: '50%',
                    left: '50%',
                    right: 'auto',
                    bottom: 'auto',
                    width: '420px',
                    maxHeight: 'calc(100% - 40px)',
                    marginRight: '-50%',
                    maxWidth: ' calc( 100% - 40px )',
                    padding: '0px',
                    transform: 'translate(-50%, -50%)',
                    background: 'var(--bs-white)',
                    borderRadius: 'var(--bs-border-radius-xl)',
                    border: 0
                },
                overlay: {
                    zIndex: 5,
                    backgroundColor: 'rgba(0, 0, 0, 0.25)',
                    backdropFilter: 'blur(10px)',
                }
            }}
            onRequestClose={() => {
                setOpenCustomizeModal(false);
            }}
            contentLabel=""
        >

            <div className={"modal-header"}>
                <h5 className="w-100 text-center text-bolder align-self-center mb-0 text-white">Oranlar</h5>
                <div onClick={() => {
                    setOpenCustomizeModal(false);
                }}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="white"
                         xmlns="http://www.w3.org/2000/svg">
                        <path d="M18 6L6 18M6 6L18 18" stroke="white" strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"></path>
                    </svg>
                </div>
            </div>
            <div className="modal-body p-3">
                <div className={"w-100 d-inline-flex flex-nowrap possibles-table"}>
                    <div className={"col runs"}>
                        {run && run.event_odds && <>
                            {
                                _.orderBy(Object.values(run.event_odds).filter((odd: any) => {
                                    if (!!BettingTypesMap[Number(selection.bettingType?.id)]?.isFobPairPick) {
                                        if (selection.bettingType.id === 1885) {
                                            return odd.horse_no.toString().includes('-') && odd.event_id.includes('EX')
                                        } else {
                                            return odd.horse_no.toString().includes('-') && !odd.event_id.includes('EX')
                                        }
                                    } else {
                                        if (selection.bettingType.id === 1886) {
                                            return odd.event_id.includes('T2');
                                        } else if (selection.bettingType.id === 1887) {
                                            return odd.event_id.includes('T3');
                                        } else if (selection.bettingType.id === 1888) {
                                            return odd.event_id.includes('T4');
                                        } else {
                                            return !odd.horse_no.toString().includes('-') && !odd.event_id.includes('T2') && !odd.event_id.includes('T3') && !odd.event_id.includes('T4')
                                        }
                                    }

                                }), [(e: any) => Number(e.win_odds)]).map((odds: any, index: any) => {
                                    return <div key={index} id={index + '-odd-row'}
                                                className="line d-flex justify-content-start">
                                        <div className="w-100">
                                            <div
                                                className="text-xxsmall possible-horse-name align-items-center cursor-pointer px-2"
                                                onMouseOver={() => {
                                                    // @ts-ignore
                                                    document.getElementById(index + '-odd-row').classList.add('high');
                                                }}
                                                onMouseOut={() => {
                                                    // @ts-ignore
                                                    document.getElementById(index + '-odd-row').classList.remove('high');
                                                }}
                                                onClick={() => {
                                                    if (!isMobile) {
                                                        var betslip: any = document.getElementById('ekuri-betslip');

                                                        if (betslip.classList.contains('closed')) {
                                                            var betslip_content: any = document.getElementById('betslip-click-area');
                                                            if (betslip_content.onClick) {
                                                                betslip_content.onClick();
                                                            } else {
                                                                betslip_content.click();
                                                            }
                                                        }
                                                    }
                                                    handleOddClick(odds)
                                                    setOpenCustomizeModal(false);
                                                }}>
                                                <div className="d-flex">
                                                    <span className="possible-horse-name">{odds.horse_no} </span>
                                                    &nbsp;
                                                    <span
                                                        className="possible-horse-name"> {getHorseNameForOdd(odds.horse_no)}</span>
                                                </div>
                                                <div className="text-xxsmall text-bold odd-btn">
                                                    {renderOdd(odds)}
                                                </div>
                                            </div>
                                        </div>

                                    </div>

                                })
                            }
                        </>}
                    </div>

                </div>

            </div>

        </Modal>
    </div>)
}
